import {
    SPORTS_LIST,
    SPORTS_LIST_SUCCESS,
    SPORTS_LIST_FAILED, LEAGUE_LIST, LEAGUE_LIST_SUCCESS, LEAGUE_LIST_FAILED
} from './../../constants/actionTypes';

const INIT_STATE = {
    sports: [],
    leagues: [],
    loading: false,
    error: null,
    leaguesLoading: true
};
type SportAction = { type: string, payload: {} | string };
const Sport = (state:State = INIT_STATE, action: SportAction) => {
    switch (action.type) {
        case SPORTS_LIST:
            return { ...state, loading: true };
        case SPORTS_LIST_SUCCESS:
            return { ...state, sports: action.payload, loading: false, error: null };
        case SPORTS_LIST_FAILED:
            return { ...state, loading: false };
        case LEAGUE_LIST:
            return { ...state, leaguesLoading: true };
        case LEAGUE_LIST_SUCCESS:
            return { ...state, leagues: action.payload, leaguesLoading: false };
        case LEAGUE_LIST_FAILED:
            return { ...state, leaguesLoading: false };

        default: return { ...state };
    }
}
export default Sport;
